import { render, staticRenderFns } from "./Karin-notification-search.vue?vue&type=template&id=4632b937&scoped=true"
import script from "./Karin-notification-search.vue?vue&type=script&lang=js"
export * from "./Karin-notification-search.vue?vue&type=script&lang=js"
import style0 from "./Karin-notification-search.vue?vue&type=style&index=0&id=4632b937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4632b937",
  null
  
)

export default component.exports